/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  PaginatedShortFormBackgroundList,
  PlaylistShortFormBackgroundsParams,
  ShortFormBackground,
  ShortFormBackgroundBulkDeleteRequest,
  ShortFormBackgroundReorderRequest,
  ShortFormBackgroundRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 플레이리스트의 모든 숏폼 배경 미디어를 순서대로 조회합니다.
 * @summary 숏폼 배경 목록 조회
 */
export const playlistShortFormBackgrounds = (
  playlistPk: string,
  params?: PlaylistShortFormBackgroundsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedShortFormBackgroundList>(
    {
      url: `/api/playlists/${playlistPk}/short-form-backgrounds/`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getPlaylistShortFormBackgroundsQueryKey = (
  playlistPk?: string,
  params?: PlaylistShortFormBackgroundsParams,
) => {
  return [
    `/api/playlists/${playlistPk}/short-form-backgrounds/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlaylistShortFormBackgroundsQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params?: PlaylistShortFormBackgroundsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlaylistShortFormBackgroundsQueryKey(playlistPk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistShortFormBackgrounds>>
  > = ({ signal }) =>
    playlistShortFormBackgrounds(playlistPk, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!playlistPk,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistShortFormBackgroundsQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistShortFormBackgrounds>>
>;
export type PlaylistShortFormBackgroundsQueryError = ErrorType<unknown>;

export function usePlaylistShortFormBackgrounds<
  TData = Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params: undefined | PlaylistShortFormBackgroundsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
          TError,
          Awaited<ReturnType<typeof playlistShortFormBackgrounds>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistShortFormBackgrounds<
  TData = Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params?: PlaylistShortFormBackgroundsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
          TError,
          Awaited<ReturnType<typeof playlistShortFormBackgrounds>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistShortFormBackgrounds<
  TData = Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params?: PlaylistShortFormBackgroundsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 숏폼 배경 목록 조회
 */

export function usePlaylistShortFormBackgrounds<
  TData = Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params?: PlaylistShortFormBackgroundsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortFormBackgrounds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistShortFormBackgroundsQueryOptions(
    playlistPk,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트에 숏폼 배경 미디어를 업로드합니다.

**이미지 자동 최적화:**
- 1080x1920 (9:16) WebP로 자동 리사이즈
- 비율이 다른 이미지는 중앙 크롭 후 리사이즈
- 192x340 썸네일 자동 생성

**영상 처리:**
- MP4, WebM 형식 지원 (최대 50MB)
- 첫 프레임에서 썸네일 자동 생성
- 영상 길이 자동 감지

**지원 형식:**
- 이미지: JPEG, PNG, WebP (최대 10MB)
- 영상: MP4, WebM (최대 50MB)
 * @summary 숏폼 배경 업로드
 */
export const playlistShortFormBackgrounds2 = (
  playlistPk: string,
  shortFormBackgroundRequest: BodyType<ShortFormBackgroundRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ShortFormBackground>(
    {
      url: `/api/playlists/${playlistPk}/short-form-backgrounds/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: shortFormBackgroundRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistShortFormBackgrounds2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistShortFormBackgrounds2>>,
    TError,
    { playlistPk: string; data: BodyType<ShortFormBackgroundRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistShortFormBackgrounds2>>,
  TError,
  { playlistPk: string; data: BodyType<ShortFormBackgroundRequest> },
  TContext
> => {
  const mutationKey = ["playlistShortFormBackgrounds2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistShortFormBackgrounds2>>,
    { playlistPk: string; data: BodyType<ShortFormBackgroundRequest> }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistShortFormBackgrounds2(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistShortFormBackgrounds2MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistShortFormBackgrounds2>>
>;
export type PlaylistShortFormBackgrounds2MutationBody =
  BodyType<ShortFormBackgroundRequest>;
export type PlaylistShortFormBackgrounds2MutationError = ErrorType<unknown>;

/**
 * @summary 숏폼 배경 업로드
 */
export const usePlaylistShortFormBackgrounds2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistShortFormBackgrounds2>>,
      TError,
      { playlistPk: string; data: BodyType<ShortFormBackgroundRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistShortFormBackgrounds2>>,
  TError,
  { playlistPk: string; data: BodyType<ShortFormBackgroundRequest> },
  TContext
> => {
  const mutationOptions =
    getPlaylistShortFormBackgrounds2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 특정 숏폼 배경 미디어의 상세 정보를 조회합니다.
 * @summary 숏폼 배경 상세 조회
 */
export const playlistShortFormBackgrounds4 = (
  playlistPk: string,
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ShortFormBackground>(
    {
      url: `/api/playlists/${playlistPk}/short-form-backgrounds/${id}/`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getPlaylistShortFormBackgrounds4QueryKey = (
  playlistPk?: string,
  id?: string,
) => {
  return [
    `/api/playlists/${playlistPk}/short-form-backgrounds/${id}/`,
  ] as const;
};

export const getPlaylistShortFormBackgrounds4QueryOptions = <
  TData = Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlaylistShortFormBackgrounds4QueryKey(playlistPk, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>
  > = ({ signal }) =>
    playlistShortFormBackgrounds4(playlistPk, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(playlistPk && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistShortFormBackgrounds4QueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>
>;
export type PlaylistShortFormBackgrounds4QueryError = ErrorType<unknown>;

export function usePlaylistShortFormBackgrounds4<
  TData = Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
          TError,
          Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistShortFormBackgrounds4<
  TData = Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
          TError,
          Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistShortFormBackgrounds4<
  TData = Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 숏폼 배경 상세 조회
 */

export function usePlaylistShortFormBackgrounds4<
  TData = Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortFormBackgrounds4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistShortFormBackgrounds4QueryOptions(
    playlistPk,
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 특정 숏폼 배경 미디어를 삭제합니다.
 * @summary 숏폼 배경 삭제
 */
export const playlistShortFormBackgrounds3 = (
  playlistPk: string,
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${playlistPk}/short-form-backgrounds/${id}/`,
      method: "DELETE",
    },
    options,
  );
};

export const getPlaylistShortFormBackgrounds3MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistShortFormBackgrounds3>>,
    TError,
    { playlistPk: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistShortFormBackgrounds3>>,
  TError,
  { playlistPk: string; id: string },
  TContext
> => {
  const mutationKey = ["playlistShortFormBackgrounds3"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistShortFormBackgrounds3>>,
    { playlistPk: string; id: string }
  > = (props) => {
    const { playlistPk, id } = props ?? {};

    return playlistShortFormBackgrounds3(playlistPk, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistShortFormBackgrounds3MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistShortFormBackgrounds3>>
>;

export type PlaylistShortFormBackgrounds3MutationError = ErrorType<unknown>;

/**
 * @summary 숏폼 배경 삭제
 */
export const usePlaylistShortFormBackgrounds3 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistShortFormBackgrounds3>>,
      TError,
      { playlistPk: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistShortFormBackgrounds3>>,
  TError,
  { playlistPk: string; id: string },
  TContext
> => {
  const mutationOptions =
    getPlaylistShortFormBackgrounds3MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 여러 숏폼 배경 미디어를 한 번에 삭제합니다.
 * @summary 숏폼 배경 일괄 삭제
 */
export const playlistBulkDelete3 = (
  playlistPk: string,
  shortFormBackgroundBulkDeleteRequest: BodyType<ShortFormBackgroundBulkDeleteRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/playlists/${playlistPk}/short-form-backgrounds/bulk-delete/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: shortFormBackgroundBulkDeleteRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistBulkDelete3MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistBulkDelete3>>,
    TError,
    {
      playlistPk: string;
      data: BodyType<ShortFormBackgroundBulkDeleteRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistBulkDelete3>>,
  TError,
  { playlistPk: string; data: BodyType<ShortFormBackgroundBulkDeleteRequest> },
  TContext
> => {
  const mutationKey = ["playlistBulkDelete3"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistBulkDelete3>>,
    { playlistPk: string; data: BodyType<ShortFormBackgroundBulkDeleteRequest> }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistBulkDelete3(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistBulkDelete3MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistBulkDelete3>>
>;
export type PlaylistBulkDelete3MutationBody =
  BodyType<ShortFormBackgroundBulkDeleteRequest>;
export type PlaylistBulkDelete3MutationError = ErrorType<unknown>;

/**
 * @summary 숏폼 배경 일괄 삭제
 */
export const usePlaylistBulkDelete3 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistBulkDelete3>>,
      TError,
      {
        playlistPk: string;
        data: BodyType<ShortFormBackgroundBulkDeleteRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistBulkDelete3>>,
  TError,
  { playlistPk: string; data: BodyType<ShortFormBackgroundBulkDeleteRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistBulkDelete3MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 숏폼 배경 미디어의 순서를 변경합니다.

item_ids 배열에 ID를 원하는 순서대로 전달하면 해당 순서로 정렬됩니다.
 * @summary 숏폼 배경 순서 변경
 */
export const playlistReorder4 = (
  playlistPk: string,
  shortFormBackgroundReorderRequest: BodyType<ShortFormBackgroundReorderRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/playlists/${playlistPk}/short-form-backgrounds/reorder/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: shortFormBackgroundReorderRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistReorder4MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistReorder4>>,
    TError,
    { playlistPk: string; data: BodyType<ShortFormBackgroundReorderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistReorder4>>,
  TError,
  { playlistPk: string; data: BodyType<ShortFormBackgroundReorderRequest> },
  TContext
> => {
  const mutationKey = ["playlistReorder4"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistReorder4>>,
    { playlistPk: string; data: BodyType<ShortFormBackgroundReorderRequest> }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistReorder4(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistReorder4MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistReorder4>>
>;
export type PlaylistReorder4MutationBody =
  BodyType<ShortFormBackgroundReorderRequest>;
export type PlaylistReorder4MutationError = ErrorType<unknown>;

/**
 * @summary 숏폼 배경 순서 변경
 */
export const usePlaylistReorder4 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistReorder4>>,
      TError,
      { playlistPk: string; data: BodyType<ShortFormBackgroundReorderRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistReorder4>>,
  TError,
  { playlistPk: string; data: BodyType<ShortFormBackgroundReorderRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistReorder4MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
